export const filter = {
    id : '',
    name : '',
    slug: '',
    created_at: "",
    updated_at: ''
};
